/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PaymentWorkflowType {
  NoPayment = 'NoPayment',
  ManualByHolder = 'ManualByHolder',
  ByUserBeforeEntering = 'ByUserBeforeEntering'
}
